import { Location } from '@reach/router';
import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import { useState } from 'react';
import { FlagButton } from '../../components/Button';
import { Container } from '../../components/Container';
import { GreatBritainFlag } from '../../components/GreatBritainFlag';
import {
  Header,
  HeaderLink,
  HeaderMenuIcon,
  HeaderTitle,
  HeaderWrapper,
  SubHeader,
  SubHeaderWrapper,
  TranslateList
} from '../../components/Header';
import { LightIcon } from '../../components/Icon';
import { SwedenFlag } from '../../components/SwedenFlag';
import {
  IDefaultProps,
  IDefaultPropsWithDataAndLocation
} from '../../IDefaultProps';
import { Query } from '../../types/graphql-types';
import { availableLocales } from '../../utils/availableLocales';
import { localeUrl } from '../../utils/localeUrl';
import { Menu } from '../Menu';

// TODO: MOVE
interface IToggle {
  onClick: () => void;
  children?: React.ReactChild[];
}
const Toggle = ({ onClick, children }: IToggle) => (
  <HeaderMenuIcon onClick={onClick}>{children}</HeaderMenuIcon>
);

const Content = ({ data, location }: IDefaultPropsWithDataAndLocation) => {
  const [open, setOpen] = useState(false);
  const onToggleClick = () => setOpen(!open);
  const company = data.contentfulCompanyInfo!;

  return (
    <>
      <Header>
        <Container>
          <HeaderWrapper>
            <HeaderTitle>
              <HeaderLink to={`/${localeUrl(location, availableLocales())}`}>
                {company && company.shortName}
              </HeaderLink>
            </HeaderTitle>
            <HeaderMenuIcon>
              <Toggle onClick={onToggleClick}>
                <LightIcon>menu</LightIcon>
              </Toggle>
            </HeaderMenuIcon>
          </HeaderWrapper>
        </Container>
      </Header>

      <SubHeader open={open}>
        <Container>
          <SubHeaderWrapper>
            <Menu />
            <TranslateList>
              <FlagButton to="/sv-se">
                <SwedenFlag />
                SV
              </FlagButton>
              <FlagButton to="/en-us">
                <GreatBritainFlag />
                EN
              </FlagButton>
            </TranslateList>
          </SubHeaderWrapper>
        </Container>
      </SubHeader>
    </>
  );
};

export const HeaderLayout = (props: IDefaultProps) => {
  const data: Query = useStaticQuery(graphql`
    query {
      contentfulCompanyInfo(node_locale: { eq: "en-US" }) {
        shortName
      }
    }
  `);

  return (
    <Location>
      {location => <Content data={data} {...location} {...props} />}
    </Location>
  );
};
